import React from 'react';
import { Header } from '../components/ui/header-2';
import { Footer } from '../components/landing/Footer';
import { Mail, MessageCircle } from 'lucide-react';

export const ContactPage = () => {
    return (
        <>
            <Header />
            <main style={{ minHeight: '100vh', background: 'var(--bg-primary)', overflowX: 'hidden' }}>
                <section style={{ padding: '120px 24px 80px', position: 'relative' }}>
                    <div className="container" style={{ position: 'relative', zIndex: 1, maxWidth: '800px', margin: '0 auto', textAlign: 'center' }}>
                        <h1 style={{ fontSize: 'clamp(2.5rem, 5vw, 3.5rem)', marginBottom: '24px', letterSpacing: '-0.02em', lineHeight: 1.1 }}>
                            Contact Us
                        </h1>
                        <p style={{ fontSize: '1.25rem', color: 'var(--text-secondary)', marginBottom: '64px', lineHeight: 1.6 }}>
                            Have questions or need support? We are here to help. Reach out to Fiescrow LLC and the Ordabell team.
                        </p>

                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '32px', textAlign: 'left' }}>
                            <div className="glass-panel" style={{ padding: '40px', background: 'var(--bg-tertiary)', border: '1px solid var(--border-subtle)', borderRadius: '16px', display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
                                <div style={{ background: 'rgba(59, 130, 246, 0.1)', padding: '16px', borderRadius: '50%', marginBottom: '24px' }}>
                                    <Mail size={32} color="var(--accent-primary)" />
                                </div>
                                <h3 style={{ fontSize: '1.25rem', fontWeight: 600, color: 'var(--text-primary)', marginBottom: '16px' }}>Email Us</h3>
                                <p style={{ color: 'var(--text-secondary)', marginBottom: '16px' }}>For general inquiries and support:</p>
                                <a href="mailto:info@fiescrow.com" style={{ color: 'var(--text-primary)', fontWeight: 500, fontSize: '1.125rem', textDecoration: 'none', marginBottom: '8px' }}>info@fiescrow.com</a>
                                <a href="mailto:ordabell@gmail.com" style={{ color: 'var(--text-primary)', fontWeight: 500, fontSize: '1.125rem', textDecoration: 'none' }}>ordabell@gmail.com</a>
                            </div>

                            <div className="glass-panel" style={{ padding: '40px', background: 'var(--bg-tertiary)', border: '1px solid var(--border-subtle)', borderRadius: '16px', display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
                                <div style={{ background: 'rgba(16, 185, 129, 0.1)', padding: '16px', borderRadius: '50%', marginBottom: '24px' }}>
                                    <MessageCircle size={32} color="#10B981" />
                                </div>
                                <h3 style={{ fontSize: '1.25rem', fontWeight: 600, color: 'var(--text-primary)', marginBottom: '16px' }}>WhatsApp</h3>
                                <p style={{ color: 'var(--text-secondary)', marginBottom: '16px' }}>Chat with us directly:</p>
                                <a href="https://wa.me/2348161535219" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--text-primary)', fontWeight: 500, fontSize: '1.125rem', textDecoration: 'none' }}>0816 153 5219</a>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
            <Footer />
        </>
    );
};
